//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ScrapList from "./ScrapList";
export default {
  components: {
    ScrapList: ScrapList
  },
  data: function data() {
    return {
      tabKeys: "2"
    };
  },
  created: function created() {
    this.tabKeys = "2";
  },
  computed: {},
  methods: {}
};